import * as React from 'react';
import { recordAnalyticsForAboutUsPageView } from '@/redux/modules/analytics';
import { useAppDispatch } from '@/redux/hooks';
import { useLocation, useParams } from 'react-router-dom';
import { waitToDispatch } from '@/utils/waitToDispatch/waitToDispatch';
import AuctionVideoPageHeaderMeta from './AuctionVideoPageHeaderMeta';
import AuctionVideoStream from '../BiddingConsole/components/AuctionVideoStream/AuctionVideoStream';
import styled, { createGlobalStyle } from 'styled-components';

type RouteParams = {
    catalogId: string;
};

const AboutUsPage = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { catalogId: catalogIdString } = useParams<RouteParams>();
    const catalogId = Number(catalogIdString);

    React.useEffect(() => {
        waitToDispatch(recordAnalyticsForAboutUsPageView, dispatch, location);
    }, [dispatch, location]);

    return (
        <Page>
            <BackgroundOverride />
            <AuctionVideoPageHeaderMeta catalogId={catalogId} />
            <AuctionVideoStream
                catalogId={catalogId}
                showExpandButton={false}
                standAlone
            />
        </Page>
    );
};

export default AboutUsPage;

const Page = styled.div`
    background-color: ${({ theme }) => theme.colors.black};
    height: 100%;
    align-items: center;
    justify-content: center;
`;

const BackgroundOverride = createGlobalStyle`
    html {
        background-color: ${({ theme }) => theme.colors.black};
    }
`;
